import Navbar from '../../Navbar/Navbar';
import Footer from '../../Footer/Footer';

import styles from './MainLayout.module.css';


const MainLayout = props => {
	return(
		<div className={styles.MainLayout}>
			<Navbar />
			<div className={styles.ContentWrapper}>
				<div className='container'>
					{props.children}
				</div>
			</div>
			<Footer />
		</div> 
	)
}

export default MainLayout;